import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/** @typedef {{ ui: import('./ui').UIState, data: import('./data').DataState}} SelfServiceReducer */

export default combineReducers({
  ui,
  data,
});
